import { createExtensionPoint } from '@interhyp/platform-plugin';
import { useMemo, Fragment } from 'react';
import { getAPM } from '@interhyp/platform-apm';
import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';

const effectExtension = createExtensionPoint(Symbol('effectExtension'), true);

function ConditionalHook({
  hook
}) {
  try {
    hook();
  } catch (error) {
    if (error instanceof Error) {
      const apm = getAPM();
      apm.captureError(error);
    }
    console.error(error);
  }
  return null;
}

function useHooks(hooks) {
  return useMemo(() => {
    return /*#__PURE__*/jsx(Fragment, {
      children: hooks.map((hook, index) => {
        return /*#__PURE__*/jsx(ConditionalHook, {
          hook: hook
        }, `${hooks.length}-${index}`);
      })
    }, hooks.length);
  }, [hooks]);
}

function EffectProvider({
  children,
  hooks = []
}) {
  const pluginHooks = effectExtension.useExtensions();
  const registeredHooks = useMemo(() => {
    return [...hooks, ...pluginHooks];
  }, [hooks, pluginHooks]);
  const hookComponents = useHooks(registeredHooks);
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [hookComponents, children]
  });
}

export { EffectProvider, effectExtension };
//# sourceMappingURL=index.js.map
